
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommSalesItemsGrid extends Serenity.EntityGrid<ECommSalesItemsRow, any> {
        protected getColumnsKey() { return 'ECommerce.ECommSalesItems'; }
        protected getDialogType() { return ECommSalesItemsDialog; }
        protected getIdProperty() { return ECommSalesItemsRow.idProperty; }
        protected getInsertPermission() { return ECommSalesItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return ECommSalesItemsRow.localTextPrefix; }
        protected getService() { return ECommSalesItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
       
        }
        
    }
}